import API from 'types/api';
import APP from 'types/app';
import _ from 'lodash';

const initialState = {
  isLogin: false,
  isLoading: false,
  isError: false,
  isLoaded: false,
  info: null,
  history: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_USER_FETCH:
      return { ...state, isLoading: true, isError: false };
    case API.GET_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLogin: true,
        isLoaded: true,
        info: payload,
      };
    case API.GET_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLogin: false,
        isLoaded: true,
        info: null,
      };
    case API.POST_AUTH_SUCCESS:
      return { ...state, isLogin: true, info: payload.user };
    case API.POST_REGISTRATION_SUCCESS:
      if (_.get(payload, 'status.completion') === 'complete') {
        return { ...state, isLogin: true, info: payload.user };
      }
      return state;
    case APP.FORCE_LOGOUT:
    case API.POST_LOGOUT_SUCCESS:
      return {
        ...state,
        isLogin: false,
        info: null,
        history: {},
      };
    case API.GET_USER_HISTORY_SUCCESS:
      if (payload.video_list.length > 0) {
        const object = payload.video_list[0];
        return {
          ...state,
          history: {
            ...state.history,
            [object.id]: {
              lastWatched: object.series_last_watched,
              watchedHistory: object.watched_history,
            },
          },
        };
      }
      return state;
    case APP.SAVE_MOVIE_POSITION:
      return {
        ...state,
        history: {
          ...state.history,
          [payload.objectId]: {
            lastWatched: {
              episode_id: payload.movieId,
            },
            watchedHistory: {
              progress: payload.position,
              percent: payload.percent,
            },
          },
        },
      };
    default:
      return state;
  }
};
